/**
 * This is the model for PurchaseOrderItem.
 */
class PurchaseOrderItem {
    /**
     * This is a default constructor for PurchaseOrderItem
     * @param {string} id
     * @param {string} itemNumber
     * @param {string} description
     * @param {number} quantity
     * @param {number} unitPrice
     * @param {string} quoteId
     * @param {string} jobName
     */
    constructor(
        id='',
        itemNumber='',
        description='',
        quantity=0,
        unitPrice=0.0,
        quoteId=null,
        jobName='',
    ) {
        this.id = id
        this.item_number = itemNumber
        this.description = description
        this.quantity = quantity
        this.unit_price = unitPrice
        this.quote_id = quoteId
        this.job_name = jobName
    }

    /**
     * Create a new PurchaseOrderItem from json
     * @param {json} json
     * @return {PurchaseOrderItem}
     */
    static from(json) {
        const item = Object.assign(new PurchaseOrderItem(), json)
        return item
    }

    /**
     * Copies PurchaseOrderItem object
     * @return {PurchaseOrderItem}
     */
    copy() {
        return PurchaseOrderItem.from(this)
    }

    /**
     * Calculates the total price
     * @return {Number}
     */
    total() {
        return Number.parseFloat(this.quantity) *
            Number.parseFloat(this.unit_price)
    }
}

module.exports = {
    PurchaseOrderItem,
}

